module.exports = __webpack_public_path__ + "static/media/Kostya.6eb1dfdf.jpg";